export const mySurveyJson = {
  "title": "MEGA | Guided installation",
  "pages": [
    {
      "name": "Server specifications",
      "title": "Server specifications",
      "elements": [
        {
          "type": "html",
          "name": "header",
          "html": "<p>Airflow only runs on Linux. Therefore, to use it on Windows, you need to run it in a virtual environment, such as Windows Subsystem for Linux (WSL). There are 2 versions of WSL. Difference between the difference WSL version can be found <a href=\"https://quantumanalytics.atlassian.net/wiki/spaces/DM/pages/2235891785/WSL\">here.</a></p>"
        },
        {
          "type": "dropdown",
          "name": "installationType",
          "title": "Installation type:",
          "isRequired": true,
          "choices": [
            {
              "value": "WSL1",
              "text": "WSL 1"
            },
            {
              "value": "WSL2",
              "text": "WSL 2"
            },
            "Docker",
            {
              "value": "pypi",
              "text": "PyPi"
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl1",
          "visibleIf": "{installationType} == 'WSL1'",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl1_info_1",
              "html": "<b> WSL1 is exclusive to Windows Server 2019 & 2017</b>, later version of Windows Server use WSL2. So far we only tested MEGA on Windows Server 2019. Therefore it is advisable to use Windows Server 2019 if you have a choice. \n<br><br>\nWSL 1 does not support Docker, so Airflow should be manually installed via the python packages."
            },
            {
              "type": "dropdown",
              "name": "windowsServerVersionWSL1",
              "title": "Select Windows Server version",
              "isRequired": true,
              "choices": [
                "Windows Server 2017",
                "Windows Server 2019",
                {
                  "value": "Windows Server 2019_no_internet",
                  "text": "Windows Server 2019 - Without Internet Access"
                }
              ],
              "showOtherItem": true
            },
            {
              "type": "html",
              "name": "wsl1_info_2",
              "visibleIf": "{windowsServerVersionWSL1} <> 'Windows Server 2019' and {windowsServerVersionWSL1} notempty and {windowsServerVersionWSL1} <> 'Windows Server 2019_no_internet'",
              "html": "<b>You selected to install MEGA on an undocumented Windows Server version ({windowsServerVersionWSL1}). Please document the steps in detail and add your notes to this survey after installation.<b>"
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl2",
          "visibleIf": "{installationType} == 'WSL2'",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl2Header",
              "html": "<p>Please note that <b>WSL 2 is only supported on Windows Server 2022</b> and <b>requires virtualization</b> to be <b>enabled</b>. This is <b>usually not enabled</b> on AWS and Azure Windows instances."
            },
            {
              "type": "dropdown",
              "name": "windowsServerVersionWSL2",
              "title": "Select Windows Server version",
              "choices": [
                "Windows Server 2022"
              ],
              "showOtherItem": true
            }
          ]
        },
        {
          "type": "panel",
          "name": "pypi_panel",
          "visibleIf": "{installationType} == 'pypi'",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "pypi_info",
              "html": "The option <b>PyPI is a placeholder. Currently no such installation documentation exists</b>. In case you explore this, please document the steps in detail and add your notes to this survey after installation."
            }
          ]
        },
        {
          "type": "dropdown",
          "name": "linuxVersion",
          "visibleIf": "{installationType} == 'Docker'",
          "title": "Select Linux Version",
          "isRequired": true,
          "choices": [
            "Ubuntu 22.04",
            "Ubuntu 24.04"
          ],
          "showOtherItem": true
        }
      ]
    },
    {
      "name": "user_info",
      "title": "User Info",
      "elements": [
        {
          "type": "html",
          "name": "_test",
          "html": "The purpose of this section is to gather information about the user who performed the installation, and their experience with it."
        },
        {
          "type": "text",
          "name": "first_name",
          "title": "First Name:"
        },
        {
          "type": "text",
          "name": "last_name",
          "title": "Last Name:"
        },
        {
          "type": "text",
          "name": "experience_general",
          "title": "Times you already performed ANY MEGA installation.",
          "inputType": "number"
        },
        {
          "type": "text",
          "name": "experience_selection",
          "title": "\nTimes you already performed this particular MEGA installation.",
          "inputType": "number"
        }
      ]
    },
    {
      "name": "PyPI - Installation",
      "visibleIf": "{installationType} == 'pypi'",
      "title": "PyPI - Installation",
      "elements": [
        {
          "type": "html",
          "name": "pypiInstallation",
          "html": "<p>Use following constrain to get the latest compatible version.</p><a href=\"https://raw.githubusercontent.com/apache/airflow/constraints-2.7.3/constraints-3.8.txt\">https://raw.githubusercontent.com/apache/airflow/constraints-2.7.3/constraints-3.8.txt</a>"
        }
      ]
    },
    {
      "name": "Docker - Installation",
      "visibleIf": "{installationType} == 'docker'",
      "title": "Docker - Installation",
      "elements": [
        {
          "type": "html",
          "name": "dockerInstallation",
          "html": "<p>Only supported on Linux and WSL 2 (Please note that WSL 2 is only supported on Windows Server 2022 and requires virtualisation to be enabled. This is usually not enabled on AWS and Azure Windows instances).</p>"
        },
        {
          "type": "html",
          "name": "dockerInstruction",
          "html": "<ol><li>Install docker engine <a href=\"https://docs.docker.com/engine/install/ubuntu/\">Ubuntu</a></li><li>Please note to clone the Airflow Docker repository into /opt/airflow. In this case the directories on the server and Docker Container are consistent.</li><li>Follow readme: <a href=\"https://bitbucket.org/quantum-analytics/airflow-docker\">quantum-analytics/airflow-docker</a></li></ol>"
        }
      ]
    },
    {
      "name": "WSL 1 - Installation",
      "visibleIf": "{installationType} == 'WSL1'",
      "title": "WSL 1 - Installation",
      "elements": [
        {
          "type": "panel",
          "name": "only_wsl1_2019_no_internet_panel_1",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_01",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "title": "",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>\n"
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl1_runAsUsernameWindows_panel",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl1_runAsUsernameWindows_instructions",
              "html": "<b>Perform</b> the <b>installation using a service user account</b> and not a personal account. The WSL <b>installation is user specific</b> so Airflow can only run from this account."
            },
            {
              "type": "text",
              "name": "wsl1_runAsUsernameWindows",
              "title": "run-as / service account username\n",
              "description": "This user requires additional permission to run without being logged on, otherwise the auto start will not run properly. The password of this user should also never expire.",
              "isRequired": true
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl1_enableWSL_panel",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl1_enableWSL_info",
              "html": "<b>Enable <a href=\"https://learn.microsoft.com/en-us/windows/wsl/install-on-server#enable-the-windows-subsystem-for-linux\">wsl</a> (Powershell):</b>\n<li>\n<samp>Enable-WindowsOptionalFeature -Online -FeatureName Microsoft-Windows-Subsystem-Linux</samp>\n"
            },
            {
              "type": "boolean",
              "name": "wsl1_enableWSL_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "wsl1_enableWSL_feedback",
              "visibleIf": "{wsl1_enableWSL_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        },
        {
          "type": "panel",
          "name": "wslLinuxVersion_panel",
          "title": "",
          "elements": [
            {
              "type": "dropdown",
              "name": "wslLinuxVersion",
              "title": "Download Linux Version for WSL",
              "description": "Select which Ubuntu Version for WSL you have downloaded. Ubuntu 22.04 ca be found at: https://aka.ms/wslubuntu2204",
              "isRequired": true,
              "showCommentArea": true,
              "choices": [
                {
                  "value": "Item 2",
                  "text": "Ubuntu 22.04"
                }
              ]
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl_installation_panel",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl1_ubuntu_installer_dir_title",
              "html": "<b>Installation directory</b>"
            },
            {
              "type": "html",
              "name": "wsl1_ubuntu_installer_dir_info_1",
              "html": "<p>\nRename <code>*.appxbundle</code> to <code>*.zip</code> and extract its content to your chosen WSL installation location (e.g., <code>D:\\wsl</code>). <br>\nThis location will become the WSL installation destination.\n</p>\n"
            },
            {
              "type": "html",
              "name": "wsl1_ubuntu_installer_dir_info_2",
              "html": "Sometimes, you might need to repeat the step \"Enable wsl\" to access the installer. For instance, if you download <code>Ubuntu2204-221101.appxbundle</code>, change it to a zip and unzip it. Inside the unzipped folder, you'll find <code>Ubuntu_2204.1.7.0_x64.appx</code>, which you should rename to zip and extract again. Place the final folder containing <code>Ubuntu.exe</code> in a logical location; this folder will be the WSL installation site."
            },
            {
              "type": "text",
              "name": "wsl1_ubuntu_installer_dir",
              "title": "Installation directory",
              "isRequired": true
            },
            {
              "type": "boolean",
              "name": "wsl1_ubuntu_installer_dir_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "wsl1_ubuntu_installer_dir_feedback",
              "visibleIf": "{wsl1_ubuntu_installer_dir_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl1_ubuntu_installer_panel",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "question7",
              "html": "<b>Ensure that WSL 1 is going to be used by default (in case there is also a restricted version of WSL2 present):</b>\n<br>\n<code>wsl --set-default-version 1</code>\n"
            },
            {
              "type": "html",
              "name": "wsl1_ubuntu_installer_info",
              "html": "<b>Install Ubuntu</b>\n<li>Run <code>Ubuntu.exe</code> <b>as</b> the <b>install user</b>, do run <b>not as admin!</b>\n<li>Follow user setup"
            },
            {
              "type": "text",
              "name": "wsl1_username",
              "title": "Linux username",
              "isRequired": true
            },
            {
              "type": "boolean",
              "name": "wsl1_ubuntu_installer_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "wsl1_ubuntu_installer_feedback",
              "visibleIf": "{wsl1_ubuntu_installer_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        },
        {
          "type": "panel",
          "name": "wsl1_ubuntu_update_panel",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "wsl1_ubuntu_update_title",
              "html": "<b>Update Ubuntu</b>"
            },
            {
              "type": "html",
              "name": "wsl1_ubuntu_update_info",
              "html": "<li>Open command prompt</li>\n<li>type <code>wsl</code></li>\n<li>Update Ubuntu: <code>sudo apt update && sudo apt upgrade</code></li>\n</ol>"
            },
            {
              "type": "boolean",
              "name": "wsl1_ubuntu_update_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "wsl1_ubuntu_update_feedback",
              "visibleIf": "{wsl1_ubuntu_update_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "db_selection_page",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1} <> 'Windows Server 2019_no_internet'",
      "title": "Choose Airflow DB",
      "elements": [
        {
          "type": "panel",
          "name": "db_selection_info_panel",
          "elements": [
            {
              "type": "html",
              "name": "db_selection_info",
              "html": "<p>\nMySQL is used as a lightweight backend database for Airflow. This database is used for logging. The default database used by Airflow is SQLite, which is not performant enough for use in production. </p><p>\n<br> \n<b>note: </b> \nwe use the <code>mysql-connector-python</code> connector instead of the <code>mysqlclient</code> due to dependency issues with <code>mysqlclient</code> in our pipenv.</p>\n<li>\n<a href=\"https://airflow.apache.org/docs/apache-airflow/stable/howto/set-up-database.html#setting-up-a-mysql-database\">Set up a Database Backend — Airflow Documentation </a>\n<li>\n<a href=\"https://ubuntu.com/server/docs/databases-mysql\">Install and configure a MySQL server | Ubuntu </a>"
            },
            {
              "type": "dropdown",
              "name": "db_selection",
              "title": "Backend database",
              "isRequired": true,
              "choices": [
                {
                  "value": "mysql",
                  "text": "MySQL"
                },
                {
                  "value": "postgres",
                  "text": "PostgreSQL"
                },
                {
                  "value": "sqlite",
                  "text": "SQLite"
                }
              ],
              "showOtherItem": true
            },
            {
              "type": "html",
              "name": "db_selection_info_2",
              "visibleIf": "{db_selection} <> 'mysql' and {db_selection} notempty",
              "html": "<b style=\"color:Tomato;\">There are currently no installation instructions for DBs other than MySQL. If you are perform an installation using another DB, please document the process and add it to this survey.</b>\n<br> \nIf unsure, ask Ole how to add to the survey."
            }
          ]
        }
      ]
    },
    {
      "name": "instructions_mysql",
      "visibleIf": "{db_selection} = 'mysql'",
      "title": "Installation and Setup MySQL Server",
      "elements": [
        {
          "type": "panel",
          "name": "install_mysql_panel",
          "elements": [
            {
              "type": "html",
              "name": "install_mysql_info",
              "html": "<b>Open WSL command line:</b>\n<li>Open Command Prompt\n<li>Type <code>wsl</code>\n<br>\n<br>\n<b>Install MySQL:</b>\n<li> <code>sudo apt install mysql-server</code>\n<br><br>\n<b>Install MySQL client:</b> \n<li><code>sudo apt-get install libmysqlclient-dev</code>"
            },
            {
              "type": "boolean",
              "name": "install_mysql_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "install_mysql_feedback",
              "visibleIf": "{install_mysql_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "only_wsl1_2019_no_internet_1",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
      "title": " WSL1 - Windows Server 2019 - No Internet 1",
      "elements": [
        {
          "type": "panel",
          "name": "question1",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_online_01",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>online machine</b>.\n</p>\n"
            },
            {
              "type": "html",
              "name": "wsl1_2019_no_internet_info_2",
              "html": "<li> Download following packages from <a href=\"https://packages.ubuntu.com/jammy/admin/\">Ubuntu – Software Packages in \"jammy\", Subsection admin:<a>\n<li><a href = \"https://pypi.org/project/python-magic/\">python3-magic </a>\n<li>apt-offline\n<li>copy them to the remote machine"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel1",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_02",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>\n"
            },
            {
              "type": "html",
              "name": "question_1",
              "html": "\nrun :\n<li> <code>sudo apt install /path/to/package/<package_name>_<version>.deb</code>\n<li> <code>sudo apt-offline set offline.sig --update --upgrade</code>\n<li>Copy <code>.sig</code>"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel2",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_online_02",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>online machine</b>.\n</p>\n"
            },
            {
              "type": "html",
              "name": "question__2",
              "html": "\n<li><code>sudo apt-offline get offline.sig --bundle upgrade.zip</code>\n<li>Copy <code>.zip</code>"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel4",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_03",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>\n"
            },
            {
              "type": "html",
              "name": "question3",
              "html": "\n<li><code>sudo apt-offline install upgrade.zip</code>\n<li><code>sudo apt-offline set offline.sig --update --upgrade --install-packages tzdata mysql-server libmysqlclient-dev python3-pip pipenv</code>\n<li><code>Copy .sig</code>"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel5",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_online_03",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>online machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "question4",
              "html": "\n<li><code>sudo apt-offline get offline.sig --bundle upgrade_install.zip</code>\n<li><code>Copy .zip</code>\n"
            }
          ]
        },
        {
          "type": "panel",
          "name": "panel6",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_04",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "question5",
              "html": "\n<li><code>sudo apt-offline install upgrade_install.zip</code>\n<li><code>sudo apt-get upgrade</code>\n<li><code>sudo apt-get install libmysqlclient-dev mysql-server python3-pip</code>\n"
            }
          ]
        }
      ]
    },
    {
      "name": "mssql_create",
      "visibleIf": "{installationType} = 'WSL1'",
      "title": "Create Database and Setup User",
      "elements": [
        {
          "type": "panel",
          "name": "mssql_create_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_05",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "mssql_create_info",
              "html": "<b>Run MySQL: </b>\n<li><code>sudo service mysql start</code>\n<br> <br> \n<b>Login MySQL using the root user</b> (since it’s the first time, the root user does not have a password set):\n<li> <code>sudo su  </code>\n<li>  <code>mysql -u root -p  </code>\n\n<br><br>\n<b>Create database and user:</b>\n<br><li><code>CREATE DATABASE airflow_db CHARACTER SET utf8mb4 COLLATE utf8mb4_unicode_ci;</code>\n<br><li><code>CREATE USER 'airflow_user' IDENTIFIED BY 'airflow_pass';</code>\n<br><li><code>GRANT ALL PRIVILEGES ON airflow_db.* TO 'airflow_user';</code>\n\n<br><br>\n<b>Change MySQL root password (if required)</b>:\n<br><code>ALTER USER 'root'@'localhost' IDENTIFIED BY 'new_password';</code>\n\n<br> <br> \nExit mysql command line via: <code>exit</code>\n"
            },
            {
              "type": "boolean",
              "name": "mssql_create_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "mssql_create_feedback",
              "visibleIf": "{mssql_create_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "only_wsl1_2019_no_internet_2",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
      "title": " WSL1 - Windows Server 2019 - No Internet 2",
      "elements": [
        {
          "type": "panel",
          "name": "wsl1_2019_no_internet_2_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_06",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "wsl1_2019_no_internet_2_info_1",
              "html": "\n<li> Follow step on, do this inside WSL or Linux: <a href=\"https://quantumanalytics.atlassian.net/wiki/spaces/DM/pages/2271313922\">Install Python Pacakges</a>"
            },
            {
              "type": "html",
              "name": "wsl1_2019_no_internet_2_info_2",
              "html": "In case of error when installing packages apply following steps:\n<li> <code>pip download {package_name}=={package_version}</code>\n<li> <code>pip wheel {package_name}</code>\n<li> Copy resulting <code>.whl</code>"
            },
            {
              "type": "boolean",
              "name": "wsl1_2019_no_internet_2_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "wsl1_2019_no_internet_2_feedback",
              "visibleIf": "{wsl1_2019_no_internet_2_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "mssql_configure_access",
      "visibleIf": "{installationType} = 'WSL1'",
      "title": "Configure access rights to MySQL folders",
      "elements": [
        {
          "type": "panel",
          "name": "mssql_configure_access_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_07",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "mssql_configure_access_info",
              "html": "<b>Grant</b> your <b>airflow user access to the mysql folder</b> \n<br>(default = <code>/var/lib/mysql</code>):\n<li>go to <code>/var/lib</code>\n<li><code>sudo usermod -aG mysql $USER</code>\n<li><code>chmod 770 mysql</code>\n\n<br><br> \nLogout and login in order to <b>apply group change</b>. To restart the shell:\n<li>\n<code>exec su -l $USER</code>.\n\n<br><br>\nTo <b>check if change was applied successfully:</b>\n<li>\n<code>groups</code></\n\n\n<br><br><br>\n<b>Ensure WSL user has access to <code>/var/run/mysqld/</code> folder:</b>\n<li>\n<code>ls -ld  /var/run/mysql</code>"
            },
            {
              "type": "boolean",
              "name": "mssql_configure_access_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "mssql_configure_access_feedback",
              "visibleIf": "{mssql_configure_access_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        },
        {
          "type": "panel",
          "name": "mssql_remove_sudo_pw_panel",
          "title": "",
          "elements": [
            {
              "type": "html",
              "name": "mssql_remove_sudo_pw_info_1",
              "html": "<b>Remove sudo password for</b> <code>sudo service mysql start</code>, in this way we will be able to run it via the <code>run_airflow.bat batch</code> script:"
            },
            {
              "type": "html",
              "name": "mssql_remove_sudo_pw_info_2",
              "html": "<b>Edit sudoers file:</b>\n<li><code>sudo visudo</code>.\nThis command opens the sudoers file in the default editor.\n<li>In the sudoers file, there is a line that grants sudo privileges to your user:\n<br> \n<code>&lt;username> ALL=(ALL:ALL) ALL</code>\n<li>\nAdd the following line to end of the file. Please <b>note that the order of the rules in this file is important. </b>\nFurther lines could undo the granted permissions:\n<br>\n<code>&lt;username&gt; ALL=(ALL) NOPASSWD: /usr/sbin/service mysql *</code>\n<li>Replace <code>&lt;username></code>  with your actual username.\n<br>\nThis line allows your user to run the <code>sudo service mysql</code> command without entering a password.\n<li>Save and close the file."
            },
            {
              "type": "boolean",
              "name": "mssql_remove_sudo_pw_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "mssql_remove_sudo_pw_feedback",
              "visibleIf": "{mssql_remove_sudo_pw_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "setup_python_and_airflow",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1} <> 'Windows Server 2019_no_internet'",
      "title": "Setup Python and Airflow",
      "elements": [
        {
          "type": "panel",
          "name": "clone_airflow_base",
          "elements": [
            {
              "type": "html",
              "name": "clone_airflow_base_info_1",
              "html": "<b>Setup Python and Airflow<b>"
            },
            {
              "type": "html",
              "name": "question2",
              "html": "<li>Open WSL Command Line and type: <code>wsl</code>.\n<li>Install pip <code>sudo apt install python3-pip</code>.\n<li>Create airflow folder (Mounted on <code>/mnt/{DRIVE_LETTER}/airflow</code>)\n<br>\n"
            },
            {
              "type": "html",
              "name": "clone_airflow_base_info_2",
              "html": "Set the AIRFLOW_HOME environment variable to the correct folder in <code>~/.bashrc</code>:\n<li><code>nano ~/.bashrc</code>\n<br><br>add the following lines: \n<li><code>export AIRFLOW_HOME=/mnt/{DRIVE_LETTER}/airflow</code>\n<li><code>export MEGA_HOME=/mnt/{DRIVE_LETTER}/airflow</code>"
            },
            {
              "type": "html",
              "name": "clone_airflow_base_info_3",
              "html": "<li>Clone the <a href=\"https://bitbucket.org/quantum-analytics/workspace/projects/MEGA\">Airflow-Base</a> repository into the <code>AIRFLOW_HOME</code> folder.\n<li>Set the paths in <code>AIRFLOW_HOME/catalog/mega_setup/mega_directory.default.json</code>.</li>\n<li>Set the paths in the <code>run_airflow.bat</code> file.</li>"
            },
            {
              "type": "boolean",
              "name": "clone_airflow_base_info_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "clone_airflow_base_info_feedback",
              "visibleIf": "{clone_airflow_base_info_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        },
        {
          "type": "panel",
          "name": "install_package_manager",
          "elements": [
            {
              "type": "html",
              "name": "install_package_manager_info_1",
              "html": "<b>Install pipenv or poetry in WSL:</b>\n<br><br>\n<b>pipenv:</b>\n<li><code>pip install pipenv</code>.<br>\n<br><br>\n<b>poetry:</b>\n<li><code>curl -sSL https://install.python-poetry.org | python3 -</code>\n<br>\n<li><code>sudo apt install python-is-python3</code>"
            },
            {
              "type": "html",
              "name": "install_package_manager_info_2",
              "html": "Go to your AIRFLOW_HOME folder and initialise pipenv and install the python packages:\n<li> <code>cd $AIRFLOW_HOME$</code>\n<li> <code>mkdir .venv</code>\n<li> <code>pipenv install</code>"
            },
            {
              "type": "boolean",
              "name": "install_package_manager_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "install_package_manager_info_feedback_bool",
              "visibleIf": "{install_package_manager_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            },
            {
              "type": "html",
              "name": "question6",
              "html": "<strong style=\"color: darkred;\">!!!!!!!!NOTE: KNOWN ERRORS!!!!!!!!</strong>\n<br><br>\n<strong style=\"color: darkred;\">Note 1:</strong>\n<br>\nThe problem was that it was <strong>not possible to recreate the pip environment</strong>, based on the official airflow constraints file. The constraints file specifies what package versions need to be used in which Airflow and Python combination. This is also the one we have on Bitbucket.\n<br><br>\nWhile the issue was not the pipenv command, we found that running <code>pipenv run pip install -r requirements.txt</code>, produced better debug output than simply running <code>pipenv install</code>.\n<br> <br>\nFor the installation to work, we made the following changes in the <code>requirements.txt</code> file:\n<br><br>  \n- deleted lines: \n<li><code>webencodings==0.5.1 ; python_version >= \"3.10\" and python_version < \"3.13\"</code>\n<li><code>unicodecsv==0.14.1 ; python_version >= \"3.10\" and python_version < \"3.13\"</code>\n<li><code>text-unidecode==1.3 ; python_version >= \"3.10\" and python_version < \"3.13\"</code>\n<li><code>pywin32==308 ; python_version >= \"3.10\" and python_version < \"3.13\" and platform_system == \"Windows\"\n</code>\n\n<br><br>  \n- reduced version number: \n<li><code>mysqlclient==2.2.6 ; python_version >= \"3.10\" and python_version < \"3.13\" and sys_platform != \"darwin\"</code> --> <code>mysqlclient>=1.4.0</code>\n<li><code>mysql-connector-python==9.1.0 ; python_version >= \"3.10\" and python_version < \"3.13\"</code> --> <code>mysql-connector-python==8.0.29</code>\n"
            }
          ]
        },
        {
          "type": "panel",
          "name": "clone_dag_plugin_repo_panel",
          "elements": [
            {
              "type": "html",
              "name": "clone_dag_plugin_repo_info",
              "html": "<b>Clone the dags and plugin Airflow repositories from \n  <a href=\"https://bitbucket.org/quantum-analytics/workspace/projects/MEGA\" target=\"_blank\">MEGA</a>:</b>\n<br>\n<li>Add the device SSH key to \n  <a href=\"https://bitbucket.org/account/settings/ssh-keys/\" target=\"_blank\">Bitbucket</a>, make sure to use the SSH key from WSL.\n<li>Go to your Airflow home folder (in wsl).<br>\n<li>Clone \n  <a href=\"https://bitbucket.org/quantum-analytics/airflow-dags-external/src/main/\"_blank\">Airflow-Dags-External </a> into the dags folder: \n<br>\n<code>git clone git@bitbucket.org:quantum-analytics/airflow-dags-external.git dags</code>\n<li> \nClone \n<a href=\"https://bitbucket.org/quantum-analytics/airflow-plugins-external/src/main/\" target=\"_blank\">Airflow-Plugins-External </a> into the plugins folder: \n<br>\n  <code>git clone git@bitbucket.org:quantum-analytics/airflow-plugins-external.git plugins</code>\n</div>\n"
            },
            {
              "type": "boolean",
              "name": "clone_dag_plugin_repo_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "clone_dag_plugin_repo_info_feedback_bool",
              "visibleIf": "{clone_dag_plugin_repo_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "only_wsl1_2019_no_internet_3",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
      "title": " WSL1 - Windows Server 2019 - No Internet 3",
      "elements": [
        {
          "type": "panel",
          "name": "wsl1_2019_no_internet_3_info_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_08",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "wsl1_2019_no_internet_3_info_1",
              "html": "\n<li> copy airflow base, dags and plugins\n<li> Set <code>AIRFLOW_HOME & MEGA_HOME</code> variable\n<li> Run airflow\n<li> Change airflow config and initalize airflow according to the next sections."
            }
          ]
        }
      ]
    },
    {
      "name": "airflow_config_page",
      "visibleIf": "{installationType} = 'WSL1'",
      "title": "Setup Airflow Config",
      "elements": [
        {
          "type": "panel",
          "name": "airflow_config",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_09",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "airflow_config_info",
              "html": "<b>Setup Airflow config</b>\n<br>\nGenerate default config with: <code>airflow config list > \"${AIRFLOW_HOME}/airflow.cfg\"</code>\n<br><br>\nThe airflow config file is stored in the <code>AIRFLOW_HOME</code> folder under the name <code>airflow.cfg</code>\n<br><br>\nOpen the config and set the following fields:\n<li>\n<code>dags_folder = /mnt/$path_to_airflow_home$/dags</code>\n<li>\n<code>executor = LocalExecutor</code>\n<li>\n<code>load_examples = False</code><br>\n<code>load_default_connections = False</code>\n<li>\n<code>plugins_folder = /mnt/$path_to_airflow_home$/plugins</code>\n<li>\n<code>sql_alchemy_conn = mysql+mysqlconnector://airflow_user:airflow_pass@localhost/airflow_db</code>\n<li>\n<code>expose_hostname = True</code>\n<li>\n<code>smtp_host = $hostname_of_mailserver_for_error_emails$ (if used)</code>\n<li>\n<code>smtp_mail_from = my_error_email_address@example.com (if used)</code>"
            },
            {
              "type": "boolean",
              "name": "airflow_config_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "airflow_config_feedback",
              "visibleIf": "{airflow_config_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "init_airflow_create_user_page",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1}",
      "title": "Initialize Airflow and create users",
      "elements": [
        {
          "type": "panel",
          "name": "init_airflow_create_user_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_10",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "init_airflow_create_user_info_1",
              "html": "<a href=\"https://airflow.apache.org/docs/apache-airflow/stable/start.html\">Airflow Documentation</a>\n<br><br>\n<b>Make sure that you have added <code>AIRFLOW_HOME</code> to the <code>~/bashrc</code> in the step \"clone airflow-base\" of the previous section.\nIf not Airflow will be initialized in the users /home/directory.\n</b>"
            },
            {
              "type": "html",
              "name": "init_airflow_create_user_info_2",
              "html": "Open wsl command line: \n<li><code>wsl</code>\n<br><br>\n<b>Initialize the airflow db</b>, link to the <code>.venv</code> created in your pipenv:\n<li> <code> $AIRFLOW_HOME$/.venv/bin/airflow db migrate</code>\n<li>e.g.  <code>/mnt/f/airflow/.venv/bin/airflow db migrate</code>\n<br><br>\n<b>Create admin user</b>\n<br>(replace <code>$AIRFLOW_HOME$</code> with the home directory e.g. <code>/mnt/f/airflow/</code>):\n<li>\n<code>\n$AIRFLOW_HOME$/.venv/bin/airflow users create \\\n    --username admin \\\n    --firstname admin \\\n    --lastname admin \\\n    --role Admin \\\n    --email airflow_admin@qbis.ch</code>"
            },
            {
              "type": "boolean",
              "name": "init_airflow_create_user_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "init_airflow_create_user_feedback",
              "visibleIf": "{init_airflow_create_user_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    },
    {
      "name": "start_airflow",
      "visibleIf": "{installationType} = 'WSL1' and {windowsServerVersionWSL1}",
      "title": "Start Airflow",
      "elements": [
        {
          "type": "panel",
          "name": "start_airflow_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_11",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "start_airflow_info_0",
              "html": "When we start Airflow, we need to make sure that it’s starting from the correct virtual environment."
            },
            {
              "type": "html",
              "name": "start_airflow_info_1",
              "html": "<strong>Option 1, from wsl:</strong>\n<br><br>\n1. start the webserver\n<li> <code>$AIRFLOW_HOME$/.venv/bin/airflow webserver</code>\n<li>e.g. <code>/mnt/f/airflow/.venv/bin/airflow webserver</code>\n<br><br>\n2. Start the scheduler:\n<li> <code>$AIRFLOW_HOME$/.venv/bin/airflow scheduler</code>\n<li>e.g. <code>/mnt/f/airflow/.venv/bin/airflow scheduler</code>"
            },
            {
              "type": "html",
              "name": "start_airflow_info_2",
              "html": "<strong>Option 2, from windows:</strong>\n<br><br>\nRun the file <code>run_airflow.bat</code> stored in the <a href=\"https://dev.azure.com/quantumanalytics/MEGA/_git/Airflow-Base\"> \nAirflow-Base repository</a>\n(make sure to modify the paths in the file to the correct <code>AIRFLOW_HOME</code> folder)"
            },
            {
              "type": "dropdown",
              "name": "start_airflow_option",
              "title": "Which option did you choose?",
              "isRequired": true,
              "choices": [
                {
                  "value": "Item 1",
                  "text": "Option 1: Via wsl"
                },
                {
                  "value": "Item 2",
                  "text": "Option 2: Via Windows"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "name": "autostart_airflow_wsl",
      "visibleIf": "{installationType} = 'WSL1' ",
      "title": "Autostart Airflow in WSL",
      "elements": [
        {
          "type": "panel",
          "name": "autostart_airflow_wsl_panel",
          "elements": [
            {
              "type": "html",
              "name": "wsl_no_internet_attention_offline_12",
              "visibleIf": "{windowsServerVersionWSL1} = 'Windows Server 2019_no_internet'",
              "html": "<p style=\"background-color: #fef7c8; color: black; padding: 10px; display: inline-block;\">\n  The following steps should be performed on the <b>offline machine</b>.\n</p>"
            },
            {
              "type": "html",
              "name": "autostart_airflow_wsl_info_0",
              "html": "The following 3 files are stored in the Airflow-base repository: \n<li><code>run_airflow.bat</code>: runs check_airflow_status.py, this will be triggered by task scheduler\n<li><code>check_airflow_status.py</code>: does the autoboot\n<li><code>catalog/mega_setup/config_check_airflow_status.py</code>: contains the configuration"
            },
            {
              "type": "html",
              "name": "autostart_airflow_wsl_info_1",
              "html": "Setup using the following steps:\n<br><br> \n1. Copy over the 3 files to your repository\n<br><br>  \n2. Set the correct variables in <code>catalog/mega_setup/config_check_airflow_status.py</code>. You might need to set:\n<br>\n<li><code>airflow_home_pid_check</code>: Windows directory of the Airflow home folder.\n<br>\n<li><code>airflow_home_start</code>: WSL directory of the Airflow home folder. <br>\n<li><code>run_meta_db_cmd</code>: The command to start the backend database.\n<br>\n<li><code>health_url</code>: API endpoint for the health status.\n<br>\n<li><code>logging_folder</code>: Folder to store the Airflow reboot logs.\n<br>\n<li><code>max_retries</code>: How often to try rebooting Airflow before failing.\n<br>\n<li><code>retry_delay</code>: Delay before retrying to boot Airflow.\n<br>\n<li><code>send_email, email_host, email_from, email_to</code>: SMTP setup to send an error email in case Airflow can’t be rebooted.\n<br><br>\n3. In task scheduler trigger the file <code>run_airflow.bat</code> during boot and every x minutes afterwards. (At other clients we set it to every 5 minutes)"
            },
            {
              "type": "boolean",
              "name": "autostart_airflow_wsl_feedback_bool",
              "title": " ",
              "description": "Anything noteworthy in this step (error)?",
              "defaultValue": "false"
            },
            {
              "type": "comment",
              "name": "autostart_airflow_wsl_feedback",
              "visibleIf": "{autostart_airflow_wsl_feedback_bool} = true",
              "title": " ",
              "description": "Please enter additional information."
            }
          ]
        }
      ]
    }
  ],
  "completeText": "Submit",
  "showPreviewBeforeComplete": true,
  "previewMode": "answeredQuestions"
};